<mat-horizontal-stepper [linear]="isLinear" #stepper>
  <mat-step [stepControl]="stepOneForm">
    <form [formGroup]="stepOneForm">
      <!--<ng-template matStepperIcon="number"></ng-template>-->
      <!--<ng-template cdkStepLabel>-->
      <!--<div class="step-bullet"></div>
      <div class="step-title"></div>-->
      <!--</ng-template><br />-->
      <div class="card border-0">
        <div class="card-body">
          <div class="row" style="margin-top:1%">
            <div class="col-md-12" style="font-size: 1.0em; text-align: justify; text-justify: distribute-all-lines">
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <p class="text-center" style="font-size: 1.8em; color: #000000; margin-top: 2%; font-family:Arial, Helvetica, sans-serif; font-weight:bold">
                      NJBOS Credit Suisse Settlement
                    </p>
                  </div>
                </div>
              </div>
              <div class="container" style="border:1px solid #bebaba">
                <br />
                <div class="text-center" style="font-weight:bold; font-size:1.3em; text-decoration:underline">
                  General Instructions
                </div>
                <br /><br />
                <h5 class="text-left;" style="font-weight:bold; text-decoration:underline">I. GENERAL INSTRUCTIONS</h5><br />

                To apply for a restitution payment in Ruotolo v. Credit Suisse Securities, Docket No. MER-C-137-13, you (or your
                authorized representative) must complete, sign, and submit this Claim Form no later than <b>OCTOBER 6, 2026</b><br /><br />

                To be able to apply, you must have purchased or otherwise acquired an interest in Credit Suisse RMBS Trust Certificates
                prior to December 18, 2013, for any of the following: Home Equity Mortgage Trust (“HEMT”) Series 2006-4, 2006-5, 2006-6,
                2007-1, and 2007-2; and Home Equity Asset Trust (“HEAT”) Series 2006-4, 2006-5, 2006-6, 2006-7, 2006-8, 2007-1, 2007-2,
                and 2007-3.<br /><br />

                You can complete and submit an online Claim Form by visiting www.NJBOSCreditSuisseSettlement.com. If you submit your
                Claim Form online, you must submit it at or before <b>11:59 p.m. (ET) on October 6,  2026</b>.<br /><br />

                To submit a Claim Form by mail, complete and sign this Claim Form and mail it to the following address postmarked
                no later than<br /> <b>October 6 , 2026</b>:

                <br /><br />

                <div class="text-center">
                  <i>NJBOS Credit Suisse Settlement</i><br />
                  c/o A.B. Data, Ltd.<br />
                  P.O. Box 173056<br />
                  Milwaukee, WI 53217<br /><br />
                </div>

                Submitting a Claim Form does not guarantee that you will get a restitution payment.<br /><br />

                If you do not submit a complete Claim Form by October 6, 2026, you will not get a restitution payment.<br /><br />

                You must provide all requested information for your Claim Form to be considered complete. If you have any questions,
                please contact the Claims Administrator at 1-877-254-8530 or info@NJBOSCreditSuisseSettlement.com.<br /><br />

                Submit a separate Claim Form for each separate legal entity or separately managed account (e.g., an individual should
                not combine his or her IRA holdings and transactions with holdings and transactions made solely in the individual’s name).<br /><br />

                If you have large numbers of transactions, you may request, or you may be requested, to submit information regarding
                your transactions in electronic files. Email  info@NJBOSCreditSuisseSettlement.com or visit www.NJBOSCreditSuisseSettlement.com
                to obtain the required electronic filing template. Files that do not comply with the required template and format may be rejected.
                Your electronic files will not be considered properly submitted unless the Claims Administrator emails you a receipt and
                confirms in writing that they were accepted. Do not assume that your electronic files were received or processed until you
                receive a confirmation email from the Claims Administrator. If you do not receive a confirmation email within ten days after
                you submit your claim, contact the Claims Administrator at info@NJBOSCreditSuisseSettlement.com.
                <br /><br />

                <div class="text-left" style="font-weight:bold; font-size:1.2em; text-decoration:underline">
                  PART 1: CLAIMANT IDENTIFICATION
                </div>
                <br />

                Fill out Part 1 with the Claimant Identification information for all RMBS Trust Certificate beneficial owner(s).  <br /><br />

                <ul>
                  <li>
                    If you purchased or acquired RMBS Trust Certificates and held those certificates in your name, you are the beneficial owner (holder) and the record owner.
                  </li>
                  <li>
                    If you purchased or acquired RMBS Trust Certificates through a third party, such as a nominee or brokerage firm, and the certificate(s) were registered in the name of the third party, you are the beneficial owner and the third party is the record owner.
                  </li>
                </ul>

                This Claim Form must be filed by the beneficial owner(s), or their legal representatives, so their information must be provided in this section.
                <ul>
                  <li>
                    Claimant Identification information, such as the beneficial owner’s Social Security (or Taxpayer Identification) Number and telephone number may be used to verify the claim. If you do not provide the requested information, your claim may be rejected.
                  </li>
                </ul>

                <div class="text-left" style="font-weight:bold; font-size:1.2em; text-decoration:underline">
                  PART 2: SCHEDULE OF RMBS TRUST CERTIFICATE TRANSACTIONS
                </div>
                <br />
                Fill out Part 2 to provide all the details about your transactions in RMBS Trust Certificates.  <br /><br />

                <ul>
                  <li>
                    Please list each transaction separately and in chronological order, by trade date, beginning with the earliest.
                  </li>
                  <li>
                    You must provide information about your transactions including any purchases, acquisitions, sales, and/or dispositions; any profits or losses; and the month, day, and year of each transaction. If you do not provide the requested transaction information, your claim may be delayed or rejected.
                  </li>
                  <li>
                    If you need more space or additional schedules, attach separate sheets with all the required information in substantially the same form. Sign and print or type your name on each additional sheet.
                  </li>
                  <li>
                    Attach copies of broker confirmations or other documents that support your listed transactions in RMBS Trust Certificates. If you do not provide supporting documents, your claim may be delayed or rejected.
                  </li>
                </ul>

                <div class="text-left" style="font-weight:bold; font-size:1.2em; text-decoration:underline">
                  PART 3: SIGN CLAIM FORM
                </div>
                <br />
                Sign the Claim Form.  <br /><br />

                <ul>
                  <li>
                    All (joint) beneficial owners must sign the Claim Form.
                  </li>
                  <li>
                    Legal representatives, such as executors, administrators, guardians, conservators, and trustees, must complete and sign this Claim Form on behalf of persons and/or entities represented by them. All legal representatives must state their title and capacities and attach documents proving their legal authority to complete the claim.
                  </li>
                </ul>

                <div class="text-left" style="font-weight:bold; font-size:1.2em; text-decoration:underline">
                  SUBMIT YOUR CLAIM FORM BY OCTOBER 6, 2026.
                </div>
                <br />
                Submit your completed Claim Form online or by mail postmarked by <b>October 6, 2026</b>.<br /><br />

                <b style="text-align:center"><u>The Claims Administrator may request additional information to process your Claim Form.</u></b><br /><br />

                <div class="row">
                  <div class="col-md-12 text-center">
                    <button class="btn btn-primary" matStepperNext>Enter Online Filing Site</button>
                  </div>
                </div>
                <br />

              </div>
            </div>
            <br />
          </div>
        </div>

        <br /><br />
      </div>

    </form>
  </mat-step>

  <mat-step [stepControl]="stepTwoForm">
    <form [formGroup]="stepTwoForm">
      <!--<ng-template cdkStepLabel>
      <div class="step-bullet"></div>
      <div class="step-title"></div>
      </ng-template>-->
      <div class="card border-0">
        <p class="card-body">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <p class="text-center" style="font-size: 1.8em; color: #000000; margin-top: 2%; font-family:Arial, Helvetica, sans-serif; font-weight:bold">
                  NJBOS Credit Suisse Settlement
                </p>
              </div>
            </div>
          </div>
          <div class="container" style="border:1px solid #bebaba">

            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center">
              <b>NAME SECTION</b>
            </div>
            <br />
            <p class="text-center" style="font-weight:bold; font-size:1.4em">
              PART I: <u>CLAIMANT INFORMATION</u>
            </p>
            <br />
            <div>
              Complete this section.
            </div>
            <br />
            <div style="font-size: 1.0em;">
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="labelBoldWeight" for="name1">Beneficial Owner’s Name (First, Middle, Last):</label>
                    <input type="text" class="form-control" formControlName="name1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.name1.errors }" />
                    <div *ngIf="f.name1.errors" class="invalid-feedback">
                      <div *ngIf="f.name1.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="f.name1.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="f.name1.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="labelBoldWeight" for="name2">Co-Beneficial Owner’s First Name:</label>
                    <input type="text" class="form-control" formControlName="name2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.name2.errors }" />
                    <div *ngIf="f.name2.errors" class="invalid-feedback">
                      <div *ngIf="f.name2.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="f.name2.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="f.name2.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="labelBoldWeight" for="name3">Entity Name (if Claimant is not an individual):</label>
                    <input type="text" class="form-control" formControlName="name3" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.name3.errors }" />
                    <div *ngIf="f.name3.errors" class="invalid-feedback">
                      <div *ngIf="f.name3.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="f.name3.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="f.name3.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="labelBoldWeight" for="name4">Representative or Custodian Name (if different from Beneficial Owner(s) listed above):</label>
                    <input type="text" class="form-control" formControlName="name4" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.name4.errors }" />
                    <div *ngIf="f.name4.errors" class="invalid-feedback">
                      <div *ngIf="f.name4.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="f.name4.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="f.name4.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center">
                <b>ADDRESS SECTION</b>
              </div>
              <br />
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="labelBoldWeight" for="street1">Address 1 (street name and number):<span style="color:red" class="required"> *</span></label>
                    <input type="text" class="form-control" formControlName="street1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.street1.errors }" />
                    <div *ngIf="f.street1.errors" class="invalid-feedback">
                      <div *ngIf="f.street1.errors.required">This field is required</div>
                      <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="f.street1.errors.maxlength">This field must not be at greater 50 characters</div>
                      <div *ngIf="f.street1.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="labelBoldWeight" for="street2">Address 2 (apartment, unit, or box number):</label>
                    <input type="text" class="form-control" formControlName="street2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.street2.errors }" />
                    <div *ngIf="f.street2.errors" class="invalid-feedback">
                      <div *ngIf="f.street2.errors.required">This field is required</div>
                      <div *ngIf="f.street2.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="f.street2.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="f.street2.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row rowformat">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="labelBoldWeight" for="country">Country:<span style="color:red" class="required"> *</span></label>
                    <select class="form-control" formControlName="country" (change)="getCountryValue($event)" [ngClass]="{ 'is-invalid': f.country.errors }">
                      <option value="">Please Select A Country</option>
                      <option *ngFor="let allcountry of allCountries">
                        {{allcountry.Name}}
                      </option>
                    </select>
                    <div *ngIf="f.country.errors" class="invalid-feedback">
                      <div *ngIf="f.country.errors.required">This field is required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="labelBoldWeight" for="city">City:<span style="color:red" class="required"> *</span></label>
                    <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.city.errors }" />
                    <div *ngIf="f.city.errors" class="invalid-feedback">
                      <div *ngIf="f.city.errors.required">This field is required</div>
                      <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="f.city.errors.maxlength">This field must not be greater than 40 characters</div>
                      <div *ngIf="f.city.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="showDivForNonUS">
                <div class="row rowformat">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="province">Province:<span style="color:red" class="required"> *</span></label>
                      <input type="text" class="form-control" formControlName="province" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.province.errors }" />
                      <div *ngIf="f.province.errors" class="invalid-feedback">
                        <div *ngIf="f.province.errors.required">This field is required</div>
                        <div *ngIf="f.province.errors.minlength">This field must be at least 2 characters</div>
                        <div *ngIf="f.province.errors.maxlength">This field must not be greater than 40 characters</div>
                        <div *ngIf="f.province.errors.pattern">
                          Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row rowformat">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="postalCode">Postal Code:</label>
                      <input type="text" class="form-control" formControlName="postalCode" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.postalCode.errors }" />
                      <div *ngIf="f.postalCode.errors" class="invalid-feedback">
                        <div *ngIf="f.postalCode.errors.maxlength">This field must not be greater than 10 characters</div>
                        <div *ngIf="f.postalCode.errors.pattern">
                          Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="showDivForUS">
                <div class="row rowformat">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="state">State:<span style="color:red" class="required"> *</span></label>
                      <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': f.state.errors }">
                        <option value="">Please Select A State</option>
                        <option *ngFor="let allstate of allStates">
                          {{allstate.Name}}
                        </option>
                      </select>
                      <div *ngIf="f.state.errors" class="invalid-feedback">
                        <div *ngIf="f.state.errors.required">This field is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="zip">Zip Code:<span style="color:red" class="required"> *</span></label>
                      <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.zip.errors }" />
                      <div *ngIf="f.zip.errors" class="invalid-feedback">
                        <div *ngIf="f.zip.errors.required">This field is required</div>
                        <div *ngIf="f.zip.errors.pattern">
                          US zip Code with format 99999 or 99999-9999 alone are accepted
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="showSSNTINRow">
                  <div class="row rowformat">
                    <div class="col-md-6">
                      <span class="labelBoldWeight">Select Option below then enter correct data in field below:<span style="color:red" class="required"> *</span></span><br />
                      <input type="radio" id="lastFourOfSSN" formControlName="optTINSSN" (change)="getOptTINSSNValue($event)" value="Last Four Of SSN">&nbsp;
                      <label for="lastFourOfSSN"> Last Four Of SSN</label>
                      &nbsp;
                      <input type="radio" id="taxIdentificationNumber" formControlName="optTINSSN" (change)="getOptTINSSNValue($event) " value="Tax Identification Number">&nbsp;
                      <label for="taxIdentificationNumber"> Tax Identification Number</label>
                      <div *ngIf="f.optTINSSN.errors" class="custom-error-original">
                        <div *ngIf="f.optTINSSN.errors.required">This field is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="row rowformat">
                    <div class="col-md-6">
                      <div class="form-group" *ngIf="showDivlast4SSN">
                        <label class="labelBoldWeight" for="last4SSN">Last 4 Of SSN:<span style="color:red" class="required"> *</span></label>
                        <input type="text" mask="0000" class="form-control" formControlName="last4SSN" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.last4SSN.errors }" />
                        <div *ngIf="f.last4SSN.errors" class="invalid-feedback">
                          <div *ngIf="f.last4SSN.errors.required">This field is required</div>
                          <div *ngIf="f.last4SSN.errors.minlength">This field must be at least 4 digits</div>
                          <div *ngIf="f.last4SSN.errors.maxlength">This field must not be greater than 4 digits</div>
                          <div *ngIf="f.last4SSN.errors.pattern">
                            Only use letters numbers
                          </div>
                        </div>
                      </div>
                      <div class="form-group" *ngIf="showDivTIN">
                        <label class="labelBoldWeight" for="tin">Tax Identification Number:<span style="color:red" class="required"> *</span></label>
                        <input type="text" mask="000000000" class="form-control" formControlName="tin" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.tin.errors }" />
                        <div *ngIf="f.tin.errors" class="invalid-feedback">
                          <div *ngIf="f.tin.errors.required">This field is required</div>
                          <div *ngIf="f.tin.errors.minlength">This field must be at least 9 digits</div>
                          <div *ngIf="f.tin.errors.maxlength">This field must not be greater than 9 digits</div>
                          <div *ngIf="f.tin.errors.pattern">
                            Only use letters numbers
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />  <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center">
              <b>CONTACT AND ACCOUNT SECTION</b>
            </div>
            <br />
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="labelBoldWeight" for="primaryPhone">Primary Phone Number:<span style="color:red" class="required"> *</span></label>
                  <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="primaryPhone" placeholder="XXX-XXX-XXXX (No dashes)" autocomplete="no" trim="blur"
                         [ngClass]="{ 'is-invalid': f.primaryPhone.errors }" />
                  <div *ngIf="f.primaryPhone.errors" class="invalid-feedback">
                    <div *ngIf="f.primaryPhone.errors.required">This field is required</div>
                    <div *ngIf="f.primaryPhone.errors.minlength">This field must be at least 10 digits</div>
                    <div *ngIf="f.primaryPhone.errors.maxlength">This field must not be greater than 10 digits</div>
                    <div *ngIf="f.primaryPhone.errors.pattern">Only use numbers</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="labelBoldWeight" for="primaryPhoneType">Primary Phone Type:<span style="color:red" class="required"> *</span></label>
                  <select class="form-control" formControlName="primaryPhoneType" [ngClass]="{ 'is-invalid': f.primaryPhoneType.errors }">
                    <option value="">Please Select Phone Type</option>
                    <option value="Cell">Mobile</option>
                    <option value="Land">Landline</option>
                  </select>
                  <div *ngIf="f.primaryPhoneType.errors" class="invalid-feedback">
                    <div *ngIf="f.primaryPhoneType.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="labelBoldWeight" for="secondaryPhone">Secondary Phone Number:</label>
                  <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="secondaryPhone" placeholder="XXX-XXX-XXXX (No dashes)" autocomplete="no" trim="blur"
                         [ngClass]="{ 'is-invalid': f.secondaryPhone.errors }" />
                  <div *ngIf="f.secondaryPhone.errors" class="invalid-feedback">
                    <div *ngIf="f.secondaryPhone.errors.required">This field is required</div>
                    <div *ngIf="f.secondaryPhone.errors.minlength">This field must be at least 10 digits</div>
                    <div *ngIf="f.secondaryPhone.errors.maxlength">This field must not be greater than 10 digits</div>
                    <div *ngIf="f.secondaryPhone.errors.pattern">Only use numbers</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="labelBoldWeight" for="secondaryPhoneType">Secondary Phone Type:<span style="color:red" class="required"> *</span></label>
                  <select class="form-control" formControlName="secondaryPhoneType" (change)="getPhoneType2Value()" [ngClass]="{ 'is-invalid': f.secondaryPhoneType.errors }">
                    <option value="">Please Select Phone Type</option>
                    <option value="Cell">Mobile</option>
                    <option value="Land">Landline</option>
                  </select>
                  <div *ngIf="f.secondaryPhoneType.errors" class="custom-error">
                    <div *ngIf="f.secondaryPhoneType.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="labelBoldWeight" for="emailAddress">Email Address:<span style="font-size:10px">(email address is not required, but if you provide it you authorize the Claims Administrator to use it in providing you with information relevant to this claim)</span></label>
                  <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.emailAddress.errors }" />
                  <div *ngIf="f.emailAddress.errors" class="invalid-feedback">
                    <div *ngIf="f.emailAddress.errors.required">This field is required</div>
                    <div *ngIf="f.emailAddress.errors.maxlength">This field must not be greater than 255 characters</div>
                    <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="labelBoldWeight" for="accountNumber">Account Number (if filing for multiple accounts, file a separate Claim Form for each account):</label>
                  <input type="text" class="form-control" formControlName="accountNumber" autocomplete="no" trim="blur"
                         [ngClass]="{ 'is-invalid': f.accountNumber.errors }" />
                  <div *ngIf="f.accountNumber.errors" class="invalid-feedback">
                    <div *ngIf="f.accountNumber.errors.required">This field is required</div>
                    <div *ngIf="f.accountNumber.errors.minlength">This field must be at least 2 digits/characters</div>
                    <div *ngIf="f.accountNumber.errors.maxlength">This field must not be at greater 12 digits/characters</div>
                    <div *ngIf="f.accountNumber.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="labelBoldWeight" for="claimantAccountType">Claimant Account Type:<span style="color:red" class="required"> *</span></label>
                  <select class="form-control" formControlName="claimantAccountType" (change)="getClaimantAccounTypeValue($event)" [ngClass]="{ 'is-invalid': f.claimantAccountType.errors }">
                    <option value="">Specify One Of The following</option>
                    <option *ngFor="let allClaimantAccountType of allClaimantAccountTypes">
                      {{allClaimantAccountType.Name}}
                    </option>
                  </select>
                  <div *ngIf="f.claimantAccountType.errors" class="invalid-feedback">
                    <div *ngIf="f.claimantAccountType.errors.required">This field is required</div>
                  </div>
                </div>
              </div>

              <div class="col-md-6" *ngIf="showDivOtherClaimantAccountType">
                <div class="form-group">
                  <label class="labelBoldWeight" for="otherClaimantAccountType">Other Claimant Account Type:<span style="color:red" class="required"> *</span></label>
                  <input type="text" class="form-control" formControlName="otherClaimantAccountType" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.otherClaimantAccountType.errors }" />
                  <div *ngIf="f.otherClaimantAccountType.errors" class="invalid-feedback">
                    <div *ngIf="f.otherClaimantAccountType.errors.required">This field is required</div>
                    <div *ngIf="f.otherClaimantAccountType.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.otherClaimantAccountType.errors.maxlength">This field must not be greater than 50 characters</div>
                    <div *ngIf="f.otherClaimantAccountType.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <ul class="list-inline float-right">
              <li>
                <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
                <button class="btn btn-primary" (click)="saveAndValidateStepTwo()">Next</button>
              </li>
            </ul>
          </div>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="stepThreeForm">
    <form [formGroup]="stepThreeForm">
      <!--<ng-template cdkStepLabel>
      <div class="step-bullet"></div>
      <div class="step-title"></div>
      </ng-template>-->
      <div class="card border-0">

        <div class="card-body">
          <div class="text-center" style="margin-top:1%; font-weight:bold; font-size:1.4em; text-decoration:underline">
            <u>PART II – SCHEDULE OF TRANSACTIONS IN RMBS TRUST CERTIFICATES</u>
          </div>
          <div class="row">
            <div class="col-md-12">
              Complete this section about the transactions you had in the Credit Suisse RMBS Trust Certificates you purchased or
              otherwise acquired prior to December 18, 2013, for any of the following: Home Equity Mortgage Trust (“HEMT”) Series 2006-4,
              2006-5, 2006-6, 2007-1, and 2007-2, and Home Equity Asset Trust (“HEAT”) Series 2006-4, 2006-5, 2006-6, 2006-7, 2006-8,
              2007-1, 2007-2, and 2007-3.  For a detailed list of included RMBS Trust Certificates, visit www.NJBOSCreditSuisseSettlement.com.
            </div>
          </div>
          <br />
          <div style="font-size: 1.0em;">
            <div class="card card-body bg-light mt-3">
              <div class="card-header bg-primary text-white">
                Purchase Transactions
              </div>
              <br />
              <div class="row mb-3">
                <div class="col-md-12">
                  <b>A. PURCHASES/ACQUISITIONS</b> –
                  List all purchases and/or acquisitions of included RMBS Trust Certificates you made.
                  <br /><br />
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="titleBold" for="purchasesTradeDate">
                          Trade Date (List Chronologically) (MM/DD/YY):
                        </label>
                        <input type="text" class="form-control" formControlName="purchasesTradeDate" onkeydown="event.preventDefault()" bsDatepicker [bsConfig]="purchasesDatePickerConfig"
                               [ngClass]="{ 'is-invalid': clicked && g.purchasesTradeDate.errors }" />
                        <div *ngIf="clicked && g.purchasesTradeDate.errors" class="invalid-feedback">
                          <div *ngIf="g.purchasesTradeDate.errors.required">This field is required</div>
                          <div *ngIf="stepThreeForm.get('purchasesTradeDate')?.hasError('buttonNotClicked') && stepThreeForm.get('purchasesTradeDate')?.dirty">
                            Remember to click the Add Button!
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="titleBold" for="purchasesQuantity">
                          Face Value:
                        </label>
                        <input type="text" class="form-control" formControlName="purchasesQuantity" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.purchasesQuantity.errors }" />
                        <div *ngIf="clicked && g.purchasesQuantity.errors" class="invalid-feedback">
                          <div *ngIf="g.purchasesQuantity.errors.required">This field is required</div>
                          <div *ngIf="g.purchasesQuantity.errors.maxlength">This field cannot be more than 11 digits</div>
                          <div *ngIf="g.purchasesQuantity.errors.pattern">Only use numbers with optional period (.) and up to 6 digits before the decimal, and 4 digits passed the decimal.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="purchasesCusip">
                          CUSIP
                        </label>
                        <select class="form-control" formControlName="purchasesCusip" [ngClass]="{ 'is-invalid': g.purchasesCusip.errors }">
                          <option value="">Please Select an Option</option>
                          <option *ngFor="let allCusip of allCusips">
                            {{allCusip.Name}}
                          </option>
                        </select>
                        <!--<select class="form-control" formControlName="purchasesCusip"
                                [ngClass]="{ 'is-invalid': g.purchasesCusip.errors }">
                          <option value="">Please Select an Option</option>
                          <option value="437084CD4">437084CD4</option>
                          <option value="437084CE2">437084CE2</option>
                          <option value="437084CF9">437084CF9</option>
                          <option value="437084CG7">437084CG7</option>
                          <option value="437084CH5">437084CH5</option>
                          <option value="437084CI3">437084CI3</option>
                          <option value="437084CJ1">437084CJ1</option>
                          <option value="437084CK8">437084CK8</option>
                          <option value="437084CL6">437084CL6</option>
                          <option value="437084CM4">437084CM4</option>
                          <option value="437084CN2">437084CN2</option>
                          <option value="437096AA8">437096AA8</option>
                          <option value="437096AB6">437096AB6</option>
                          <option value="437096AC4">437096AC4</option>
                          <option value="437096AD2">437096AD2</option>
                          <option value="437096AE0">437096AE0</option>
                          <option value="437096AF7">437096AF7</option>
                          <option value="437096AG5">437096AG5</option>
                          <option value="437096AH3">437096AH3</option>
                          <option value="437096AI1">437096AI1</option>
                          <option value="437096AJ9">437096AJ9</option>
                          <option value="437096AK6">437096AK6</option>
                          <option value="437096AL4">437096AL4</option>
                          <option value="437097AA6">437097AA6</option>
                          <option value="437097AB4">437097AB4</option>
                          <option value="437097AC2">437097AC2</option>
                          <option value="437097AD0">437097AD0</option>
                          <option value="437097AE8">437097AE8</option>
                          <option value="437097AF5">437097AF5</option>
                          <option value="437097AG3">437097AG3</option>
                          <option value="437097AH1">437097AH1</option>
                          <option value="437097AI9">437097AI9</option>
                          <option value="437097AJ7">437097AJ7</option>
                          <option value="437097AK4">437097AK4</option>
                          <option value="437097AL2">437097AL2</option>
                          <option value="43709NAA1">43709NAA1</option>
                          <option value="43709NAB9">43709NAB9</option>
                          <option value="43709NAC7">43709NAC7</option>
                          <option value="43709NAD5">43709NAD5</option>
                          <option value="43709NAE3">43709NAE3</option>
                          <option value="43709NAF0">43709NAF0</option>
                          <option value="43709NAG8">43709NAG8</option>
                          <option value="43709NAH6">43709NAH6</option>
                          <option value="43709NAI4">43709NAI4</option>
                          <option value="43709NAJ2">43709NAJ2</option>
                          <option value="43709NAK9">43709NAK9</option>
                          <option value="43709NAL7">43709NAL7</option>
                          <option value="43709QAA7">43709QAA7</option>
                          <option value="43709QAB5">43709QAB5</option>
                          <option value="43709QAC3">43709QAC3</option>
                          <option value="43709QAD1">43709QAD1</option>
                          <option value="43709QAE9">43709QAE9</option>
                          <option value="43709QAF6">43709QAF6</option>
                          <option value="43709QAG4">43709QAG4</option>
                          <option value="43709QAH2">43709QAH2</option>
                          <option value="43709QAI0">43709QAI0</option>
                          <option value="43709QAJ8">43709QAJ8</option>
                          <option value="43709QAK5">43709QAK5</option>
                          <option value="43709QAL3">43709QAL3</option>
                          <option value="43710LAA0">43710LAA0</option>
                          <option value="43710LAB8">43710LAB8</option>
                          <option value="43710LAC6">43710LAC6</option>
                          <option value="43710LAD4">43710LAD4</option>
                          <option value="43710LAE2">43710LAE2</option>
                          <option value="43710LAF9">43710LAF9</option>
                          <option value="43710LAG7">43710LAG7</option>
                          <option value="43710LAH5">43710LAH5</option>
                          <option value="43710LAI3">43710LAI3</option>
                          <option value="43710LAJ1">43710LAJ1</option>
                          <option value="43710LAK8">43710LAK8</option>
                          <option value="43710LAL6">43710LAL6</option>
                          <option value="43710NAA6">43710NAA6</option>
                          <option value="43710NAB4">43710NAB4</option>
                          <option value="43710NAC2">43710NAC2</option>
                          <option value="43710NAD0">43710NAD0</option>
                          <option value="43710NAE8">43710NAE8</option>
                          <option value="43710NAF5">43710NAF5</option>
                          <option value="43710NAG3">43710NAG3</option>
                          <option value="43710NAH1">43710NAH1</option>
                          <option value="43710NAI9">43710NAI9</option>
                          <option value="43710NAJ7">43710NAJ7</option>
                          <option value="43710NAK4">43710NAK4</option>
                          <option value="43710NAL2">43710NAL2</option>
                          <option value="43710TAA5">43710TAA5</option>
                          <option value="43710TAB3">43710TAB3</option>
                          <option value="43710TAC1">43710TAC1</option>
                          <option value="43710TAD9">43710TAD9</option>
                          <option value="43710TAE7">43710TAE7</option>
                          <option value="43710TAF4">43710TAF4</option>
                          <option value="43710TAG2">43710TAG2</option>
                          <option value="43710TAH0">43710TAH0</option>
                          <option value="43710TAI8">43710TAI8</option>
                          <option value="43710TAJ6">43710TAJ6</option>
                          <option value="43710TAK3">43710TAK3</option>
                          <option value="43710TAL1">43710TAL1</option>
                          <option value="43709JAA0">43709JAA0</option>
                          <option value="43709JAB8">43709JAB8</option>
                          <option value="43709JAC6">43709JAC6</option>
                          <option value="43709JAD4">43709JAD4</option>
                          <option value="43709JAE2">43709JAE2</option>
                          <option value="43709JAF9">43709JAF9</option>
                          <option value="43709JAG7">43709JAG7</option>
                          <option value="43709JAH5">43709JAH5</option>
                          <option value="43709JAI3">43709JAI3</option>
                          <option value="43709JAJ1">43709JAJ1</option>
                          <option value="43709JAK8">43709JAK8</option>
                          <option value="43709JAL6">43709JAL6</option>
                          <option value="43709JAM4">43709JAM4</option>
                          <option value="43709JAN2">43709JAN2</option>
                          <option value="43709JAO0">43709JAO0</option>
                          <option value="43709PAA6">43709PAA6</option>
                          <option value="43709PAB4">43709PAB4</option>
                          <option value="43709PAC2">43709PAC2</option>
                          <option value="43709PAD0">43709PAD0</option>
                          <option value="43709PAE8">43709PAE8</option>
                          <option value="43709PAF5">43709PAF5</option>
                          <option value="43709PAG3">43709PAG3</option>
                          <option value="43709PAH1">43709PAH1</option>
                          <option value="43709PAI9">43709PAI9</option>
                          <option value="43709PAK4">43709PAK4</option>
                          <option value="43709PAL2">43709PAL2</option>
                          <option value="43709PAM0">43709PAM0</option>
                          <option value="43709PAN8">43709PAN8</option>
                          <option value="43709PAO6">43709PAO6</option>
                          <option value="43709YAA7">43709YAA7</option>
                          <option value="43709YAB5">43709YAB5</option>
                          <option value="43709YAC3">43709YAC3</option>
                          <option value="43709YAD1">43709YAD1</option>
                          <option value="43709YAE9">43709YAE9</option>
                          <option value="43709YAF6">43709YAF6</option>
                          <option value="43709YAG4">43709YAG4</option>
                          <option value="43709YAH2">43709YAH2</option>
                          <option value="43709YAI0">43709YAI0</option>
                          <option value="43709YAJ8">43709YAJ8</option>
                          <option value="43709YAK5">43709YAK5</option>
                          <option value="43709YAL3">43709YAL3</option>
                          <option value="43709YAM1">43709YAM1</option>
                          <option value="43709YAN9">43709YAN9</option>
                          <option value="43709YAO7">43709YAO7</option>
                          <option value="43710AAA5">43710AAA5</option>
                          <option value="43710AAB3">43710AAB3</option>
                          <option value="43710AAC1">43710AAC1</option>
                          <option value="43710AAD9">43710AAD9</option>
                          <option value="43710AAE7">43710AAE7</option>
                          <option value="43710AAF4">43710AAF4</option>
                          <option value="43710AAG2">43710AAG2</option>
                          <option value="43710AAH0">43710AAH0</option>
                          <option value="43710AAI8">43710AAI8</option>
                          <option value="43710AAJ6">43710AAJ6</option>
                          <option value="43710AAK3">43710AAK3</option>
                          <option value="43710AAL1">43710AAL1</option>
                          <option value="43710AAM9">43710AAM9</option>
                          <option value="43710AAN7">43710AAN7</option>
                          <option value="43710AAO5">43710AAO5</option>
                          <option value="43710CAA2">43710CAA2</option>
                          <option value="43710CAB0">43710CAB0</option>
                          <option value="43710CAC8">43710CAC8</option>
                          <option value="43710CAD6">43710CAD6</option>
                          <option value="43710CAE4">43710CAE4</option>
                          <option value="43710CAF1">43710CAF1</option>
                          <option value="43710CAG9">43710CAG9</option>
                          <option value="43710CAH7">43710CAH7</option>
                          <option value="43710CAI5">43710CAI5</option>
                          <option value="43710CAJ3">43710CAJ3</option>
                          <option value="43710CAK0">43710CAK0</option>
                          <option value="43710CAL8">43710CAL8</option>
                          <option value="43710CAM6">43710CAM6</option>
                          <option value="43710CAN4">43710CAN4</option>
                          <option value="43710CAO2">43710CAO2</option>
                        </select>-->
                        <div *ngIf="clicked && g.purchasesCusip.errors" class="invalid-feedback">
                          <div *ngIf="g.purchasesCusip.errors.required">This field is required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="purchasesPricePerShare">
                          Price (excluding interest, commissions, taxes and fees):
                        </label>
                        <input type="text" class="form-control" formControlName="purchasesPricePerShare" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.purchasesPricePerShare.errors }" />
                        <div *ngIf="clicked && g.purchasesPricePerShare.errors" class="invalid-feedback">
                          <div *ngIf="g.purchasesPricePerShare.errors.required">This field is required</div>
                          <div *ngIf="g.purchasesPricePerShare.errors.maxlength">This field cannot be more than 11 digits</div>
                          <div *ngIf="g.purchasesPricePerShare.errors.pattern">Only use numbers with optional period (.) and up to 6 digits before the decimal, and 4 digits passed the decimal.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="purchasesTotalPrice">
                          Total Proceeds (excluding interest, commissions, taxes and fees):
                        </label>
                        <input type="text" class="form-control" formControlName="purchasesTotalPrice" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.purchasesTotalPrice.errors }" />
                        <div *ngIf="clicked && g.purchasesTotalPrice.errors" class="invalid-feedback">
                          <div *ngIf="g.purchasesTotalPrice.errors.required">This field is required</div>
                          <div *ngIf="g.purchasesTotalPrice.errors.maxlength">This field cannot be more than 11 digits</div>
                          <div *ngIf="g.purchasesTotalPrice.errors.pattern">Only use numbers with optional period (.) and up to 6 digits before the decimal, and 4 digits passed the decimal.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button type="button" (click)="addPurchasesData()" class="btn btn-success">Add Purchase Information</button>&nbsp;
                      <button type="button" (click)="clearPurchasesData()" class="btn btn-danger btn-sm">Clear Purchase Information</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table" #listofFiles>
                    <thead>
                      <tr>
                        <th class="tableHeaderFormattedText">Trade Date</th>
                        <th class="tableHeaderFormattedText">Face Value</th>
                        <th class="tableHeaderFormattedText">CUSIP</th>
                        <th class="tableHeaderFormattedText">Price Per Share</th>
                        <th class="tableHeaderFormattedText">Total Cost</th>
                        <th class="tableHeaderFormattedText">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let pl of purchaseList; let i = index">
                        <td class="hidden">{{i}}</td>
                        <td class="tableRowFormattedText">{{pl.TradeDate | date:'MM/dd/yyyy'}}</td>
                        <td class="tableRowFormattedText">{{pl.Quantity}}</td>
                        <td class="tableRowFormattedText">{{pl.Cusip}}</td>
                        <td class="tableRowFormattedText">{{pl.PricePerShare}}</td>
                        <td class="tableRowFormattedText">{{pl.TotalPrice}}</td>
                        <td>
                          <button type="button" class="btn btn-danger"
                                  (click)="removePurchasesRow(i)">
                            Remove
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="card card-body bg-light mt-3">
              <div class="card-header bg-primary text-white">
                Distribution Transactions
              </div>
              <br />
              <div class="row mb-3">
                <div class="col-md-12">
                  <b>B.	DISTRIBUTIONS</b> –
                  List all principal distributions of included RMBS Trust Certificates that you received prior to December 18, 2013.<br /><br />
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="titleBold" for="distributionsTradeDate">
                          Trade Date (List Chronologically) (MM/DD/YY):
                        </label>
                        <input type="text" class="form-control" formControlName="distributionsTradeDate" onkeydown="event.preventDefault()" bsDatepicker [bsConfig]="distributionsDatePickerConfig"
                               [ngClass]="{ 'is-invalid': clicked && g.distributionsTradeDate.errors }" />
                        <div *ngIf="clicked && g.distributionsTradeDate.errors" class="invalid-feedback">
                          <div *ngIf="g.distributionsTradeDate.errors.required">This field is required</div>
                          <div *ngIf="stepThreeForm.get('distributionsTradeDate')?.hasError('buttonNotClicked') && stepThreeForm.get('distributionsTradeDate')?.dirty">
                            Remember to click the Add Button!
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="titleBold" for="distributionsQuantity">
                          Face Value:
                        </label>
                        <input type="text" class="form-control" formControlName="distributionsQuantity" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.distributionsQuantity.errors }" />
                        <div *ngIf="clicked && g.distributionsQuantity.errors" class="invalid-feedback">
                          <div *ngIf="g.distributionsQuantity.errors.required">This field is required</div>
                          <div *ngIf="g.distributionsQuantity.errors.maxlength">This field cannot be more than 11 digits</div>
                          <div *ngIf="g.distributionsQuantity.errors.pattern">Only use numbers with optional period (.) and up to 6 digits before the decimal, and 4 digits passed the decimal.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="distributionsCusip">
                          CUSIP
                        </label>

                        <select class="form-control" formControlName="distributionsCusip" [ngClass]="{ 'is-invalid': g.distributionsCusip.errors }">
                          <option value="">Please Select an Option</option>
                          <option *ngFor="let allCusip of allCusips">
                            {{allCusip.Name}}
                          </option>
                        </select>


                        <!--<select class="form-control" formControlName="distributionsCusip"
                                [ngClass]="{ 'is-invalid': g.distributionsCusip.errors }">
                          <option value="">Please Select an Option</option>
                          <option value="437084CD4">437084CD4</option>
                          <option value="437084CE2">437084CE2</option>
                          <option value="437084CF9">437084CF9</option>
                          <option value="437084CG7">437084CG7</option>
                          <option value="437084CH5">437084CH5</option>
                          <option value="437084CI3">437084CI3</option>
                          <option value="437084CJ1">437084CJ1</option>
                          <option value="437084CK8">437084CK8</option>
                          <option value="437084CL6">437084CL6</option>
                          <option value="437084CM4">437084CM4</option>
                          <option value="437084CN2">437084CN2</option>
                          <option value="437096AA8">437096AA8</option>
                          <option value="437096AB6">437096AB6</option>
                          <option value="437096AC4">437096AC4</option>
                          <option value="437096AD2">437096AD2</option>
                          <option value="437096AE0">437096AE0</option>
                          <option value="437096AF7">437096AF7</option>
                          <option value="437096AG5">437096AG5</option>
                          <option value="437096AH3">437096AH3</option>
                          <option value="437096AI1">437096AI1</option>
                          <option value="437096AJ9">437096AJ9</option>
                          <option value="437096AK6">437096AK6</option>
                          <option value="437096AL4">437096AL4</option>
                          <option value="437097AA6">437097AA6</option>
                          <option value="437097AB4">437097AB4</option>
                          <option value="437097AC2">437097AC2</option>
                          <option value="437097AD0">437097AD0</option>
                          <option value="437097AE8">437097AE8</option>
                          <option value="437097AF5">437097AF5</option>
                          <option value="437097AG3">437097AG3</option>
                          <option value="437097AH1">437097AH1</option>
                          <option value="437097AI9">437097AI9</option>
                          <option value="437097AJ7">437097AJ7</option>
                          <option value="437097AK4">437097AK4</option>
                          <option value="437097AL2">437097AL2</option>
                          <option value="43709NAA1">43709NAA1</option>
                          <option value="43709NAB9">43709NAB9</option>
                          <option value="43709NAC7">43709NAC7</option>
                          <option value="43709NAD5">43709NAD5</option>
                          <option value="43709NAE3">43709NAE3</option>
                          <option value="43709NAF0">43709NAF0</option>
                          <option value="43709NAG8">43709NAG8</option>
                          <option value="43709NAH6">43709NAH6</option>
                          <option value="43709NAI4">43709NAI4</option>
                          <option value="43709NAJ2">43709NAJ2</option>
                          <option value="43709NAK9">43709NAK9</option>
                          <option value="43709NAL7">43709NAL7</option>
                          <option value="43709QAA7">43709QAA7</option>
                          <option value="43709QAB5">43709QAB5</option>
                          <option value="43709QAC3">43709QAC3</option>
                          <option value="43709QAD1">43709QAD1</option>
                          <option value="43709QAE9">43709QAE9</option>
                          <option value="43709QAF6">43709QAF6</option>
                          <option value="43709QAG4">43709QAG4</option>
                          <option value="43709QAH2">43709QAH2</option>
                          <option value="43709QAI0">43709QAI0</option>
                          <option value="43709QAJ8">43709QAJ8</option>
                          <option value="43709QAK5">43709QAK5</option>
                          <option value="43709QAL3">43709QAL3</option>
                          <option value="43710LAA0">43710LAA0</option>
                          <option value="43710LAB8">43710LAB8</option>
                          <option value="43710LAC6">43710LAC6</option>
                          <option value="43710LAD4">43710LAD4</option>
                          <option value="43710LAE2">43710LAE2</option>
                          <option value="43710LAF9">43710LAF9</option>
                          <option value="43710LAG7">43710LAG7</option>
                          <option value="43710LAH5">43710LAH5</option>
                          <option value="43710LAI3">43710LAI3</option>
                          <option value="43710LAJ1">43710LAJ1</option>
                          <option value="43710LAK8">43710LAK8</option>
                          <option value="43710LAL6">43710LAL6</option>
                          <option value="43710NAA6">43710NAA6</option>
                          <option value="43710NAB4">43710NAB4</option>
                          <option value="43710NAC2">43710NAC2</option>
                          <option value="43710NAD0">43710NAD0</option>
                          <option value="43710NAE8">43710NAE8</option>
                          <option value="43710NAF5">43710NAF5</option>
                          <option value="43710NAG3">43710NAG3</option>
                          <option value="43710NAH1">43710NAH1</option>
                          <option value="43710NAI9">43710NAI9</option>
                          <option value="43710NAJ7">43710NAJ7</option>
                          <option value="43710NAK4">43710NAK4</option>
                          <option value="43710NAL2">43710NAL2</option>
                          <option value="43710TAA5">43710TAA5</option>
                          <option value="43710TAB3">43710TAB3</option>
                          <option value="43710TAC1">43710TAC1</option>
                          <option value="43710TAD9">43710TAD9</option>
                          <option value="43710TAE7">43710TAE7</option>
                          <option value="43710TAF4">43710TAF4</option>
                          <option value="43710TAG2">43710TAG2</option>
                          <option value="43710TAH0">43710TAH0</option>
                          <option value="43710TAI8">43710TAI8</option>
                          <option value="43710TAJ6">43710TAJ6</option>
                          <option value="43710TAK3">43710TAK3</option>
                          <option value="43710TAL1">43710TAL1</option>
                          <option value="43709JAA0">43709JAA0</option>
                          <option value="43709JAB8">43709JAB8</option>
                          <option value="43709JAC6">43709JAC6</option>
                          <option value="43709JAD4">43709JAD4</option>
                          <option value="43709JAE2">43709JAE2</option>
                          <option value="43709JAF9">43709JAF9</option>
                          <option value="43709JAG7">43709JAG7</option>
                          <option value="43709JAH5">43709JAH5</option>
                          <option value="43709JAI3">43709JAI3</option>
                          <option value="43709JAJ1">43709JAJ1</option>
                          <option value="43709JAK8">43709JAK8</option>
                          <option value="43709JAL6">43709JAL6</option>
                          <option value="43709JAM4">43709JAM4</option>
                          <option value="43709JAN2">43709JAN2</option>
                          <option value="43709JAO0">43709JAO0</option>
                          <option value="43709PAA6">43709PAA6</option>
                          <option value="43709PAB4">43709PAB4</option>
                          <option value="43709PAC2">43709PAC2</option>
                          <option value="43709PAD0">43709PAD0</option>
                          <option value="43709PAE8">43709PAE8</option>
                          <option value="43709PAF5">43709PAF5</option>
                          <option value="43709PAG3">43709PAG3</option>
                          <option value="43709PAH1">43709PAH1</option>
                          <option value="43709PAI9">43709PAI9</option>
                          <option value="43709PAK4">43709PAK4</option>
                          <option value="43709PAL2">43709PAL2</option>
                          <option value="43709PAM0">43709PAM0</option>
                          <option value="43709PAN8">43709PAN8</option>
                          <option value="43709PAO6">43709PAO6</option>
                          <option value="43709YAA7">43709YAA7</option>
                          <option value="43709YAB5">43709YAB5</option>
                          <option value="43709YAC3">43709YAC3</option>
                          <option value="43709YAD1">43709YAD1</option>
                          <option value="43709YAE9">43709YAE9</option>
                          <option value="43709YAF6">43709YAF6</option>
                          <option value="43709YAG4">43709YAG4</option>
                          <option value="43709YAH2">43709YAH2</option>
                          <option value="43709YAI0">43709YAI0</option>
                          <option value="43709YAJ8">43709YAJ8</option>
                          <option value="43709YAK5">43709YAK5</option>
                          <option value="43709YAL3">43709YAL3</option>
                          <option value="43709YAM1">43709YAM1</option>
                          <option value="43709YAN9">43709YAN9</option>
                          <option value="43709YAO7">43709YAO7</option>
                          <option value="43710AAA5">43710AAA5</option>
                          <option value="43710AAB3">43710AAB3</option>
                          <option value="43710AAC1">43710AAC1</option>
                          <option value="43710AAD9">43710AAD9</option>
                          <option value="43710AAE7">43710AAE7</option>
                          <option value="43710AAF4">43710AAF4</option>
                          <option value="43710AAG2">43710AAG2</option>
                          <option value="43710AAH0">43710AAH0</option>
                          <option value="43710AAI8">43710AAI8</option>
                          <option value="43710AAJ6">43710AAJ6</option>
                          <option value="43710AAK3">43710AAK3</option>
                          <option value="43710AAL1">43710AAL1</option>
                          <option value="43710AAM9">43710AAM9</option>
                          <option value="43710AAN7">43710AAN7</option>
                          <option value="43710AAO5">43710AAO5</option>
                          <option value="43710CAA2">43710CAA2</option>
                          <option value="43710CAB0">43710CAB0</option>
                          <option value="43710CAC8">43710CAC8</option>
                          <option value="43710CAD6">43710CAD6</option>
                          <option value="43710CAE4">43710CAE4</option>
                          <option value="43710CAF1">43710CAF1</option>
                          <option value="43710CAG9">43710CAG9</option>
                          <option value="43710CAH7">43710CAH7</option>
                          <option value="43710CAI5">43710CAI5</option>
                          <option value="43710CAJ3">43710CAJ3</option>
                          <option value="43710CAK0">43710CAK0</option>
                          <option value="43710CAL8">43710CAL8</option>
                          <option value="43710CAM6">43710CAM6</option>
                          <option value="43710CAN4">43710CAN4</option>
                          <option value="43710CAO2">43710CAO2</option>
                        </select>-->
                        <div *ngIf="clicked && g.distributionsCusip.errors" class="invalid-feedback">
                          <div *ngIf="g.distributionsCusip.errors.required">This field is required</div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="distributionsPricePerShare">
                          Price (excluding interest, commissions, taxes and fees):
                        </label>
                        <input type="text" class="form-control" formControlName="distributionsPricePerShare" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.distributionsPricePerShare.errors }" />
                        <div *ngIf="clicked && g.distributionsPricePerShare.errors" class="invalid-feedback">
                          <div *ngIf="g.distributionsPricePerShare.errors.required">This field is required</div>
                          <div *ngIf="g.distributionsPricePerShare.errors.maxlength">This field cannot be more than 11 digits</div>
                          <div *ngIf="g.distributionsPricePerShare.errors.pattern">Only use numbers with optional period (.) and up to 6 digits before the decimal, and 4 digits passed the decimal.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="distributionsTotalPrice">
                          Total Proceeds (excluding interest, commissions, taxes and fees):
                        </label>
                        <input type="text" class="form-control" formControlName="distributionsTotalPrice" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.distributionsTotalPrice.errors }" />
                        <div *ngIf="clicked && g.distributionsTotalPrice.errors" class="invalid-feedback">
                          <div *ngIf="g.distributionsTotalPrice.errors.required">This field is required</div>
                          <div *ngIf="g.distributionsTotalPrice.errors.maxlength">This field cannot be more than 11 digits</div>
                          <div *ngIf="g.distributionsTotalPrice.errors.pattern">Only use numbers with optional period (.) and up to 6 digits before the decimal, and 4 digits passed the decimal.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button type="button" (click)="addDistributionsData()" class="btn btn-success">Add Distribution Information</button>&nbsp;
                      <button type="button" (click)="clearDistributionsData()" class="btn btn-danger btn-sm">Clear Distribution Information</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table" #listofFiles>
                    <thead>
                      <tr>
                        <th class="tableHeaderFormattedText">Trade Date</th>
                        <th class="tableHeaderFormattedText">Face Value</th>
                        <th class="tableHeaderFormattedText">CUSIP</th>
                        <th class="tableHeaderFormattedText">Price</th>
                        <th class="tableHeaderFormattedText">Total Proceeds</th>
                        <th class="tableHeaderFormattedText">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let dl of distributionList; let i = index">
                        <td class="hidden">{{i}}</td>
                        <td class="tableRowFormattedText">{{dl.TradeDate | date:'MM/dd/yyyy'}}</td>
                        <td class="tableRowFormattedText">{{dl.Quantity}}</td>
                        <td class="tableRowFormattedText">{{dl.Cusip}}</td>
                        <td class="tableRowFormattedText">{{dl.PricePerShare}}</td>
                        <td class="tableRowFormattedText">{{dl.TotalPrice}}</td>
                        <td>
                          <button type="button" class="btn btn-danger"
                                  (click)="removeDistributionsRow(i)">
                            Remove
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="card card-body bg-light mt-3">
              <div class="card-header bg-primary text-white">
                Sale Transactions
              </div>
              <br />
              <div class="row mb-3">
                <div class="col-md-12">
                  <b>C.	SALES/DISPOSITIONS</b> –
                  List all sales and/or dispositions of included RMBS Trust Certificates you made prior to December 18, 2013.<br /><br />
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="titleBold" for="salesTradeDate">
                          Trade Date (List Chronologically) (MM/DD/YY):
                        </label>
                        <input type="text" class="form-control" formControlName="salesTradeDate" onkeydown="event.preventDefault()" bsDatepicker [bsConfig]="salesDatePickerConfig"
                               [ngClass]="{ 'is-invalid': clicked && g.salesTradeDate.errors }" />
                        <div *ngIf="clicked && g.salesTradeDate.errors" class="invalid-feedback">
                          <div *ngIf="g.salesTradeDate.errors.required">This field is required</div>
                          <div *ngIf="stepThreeForm.get('salesTradeDate')?.hasError('buttonNotClicked') && stepThreeForm.get('salesTradeDate')?.dirty">
                            Remember to click the Add Button!
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="titleBold" for="salesQuantity">
                          Face Value:
                        </label>
                        <input type="text" class="form-control" formControlName="salesQuantity" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.salesQuantity.errors }" />
                        <div *ngIf="clicked && g.salesQuantity.errors" class="invalid-feedback">
                          <div *ngIf="g.salesQuantity.errors.required">This field is required</div>
                          <div *ngIf="g.salesQuantity.errors.maxlength">This field cannot be more than 11 digits</div>
                          <div *ngIf="g.salesQuantity.errors.pattern">Only use numbers with optional period (.) and up to 6 digits before the decimal, and 4 digits passed the decimal.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="salesCusip">
                          CUSIP
                        </label>
                        <select class="form-control" formControlName="salesCusip" [ngClass]="{ 'is-invalid': g.salesCusip.errors }">
                          <option value="">Please Select an Option</option>
                          <option *ngFor="let allCusip of allCusips">
                            {{allCusip.Name}}
                          </option>
                        </select>

                        <!--<select class="form-control" formControlName="salesCusip"
                                [ngClass]="{ 'is-invalid': g.salesCusip.errors }">
                          <option value="">Please Select an Option</option>
                          <option value="437084CD4">437084CD4</option>
                          <option value="437084CE2">437084CE2</option>
                          <option value="437084CF9">437084CF9</option>
                          <option value="437084CG7">437084CG7</option>
                          <option value="437084CH5">437084CH5</option>
                          <option value="437084CI3">437084CI3</option>
                          <option value="437084CJ1">437084CJ1</option>
                          <option value="437084CK8">437084CK8</option>
                          <option value="437084CL6">437084CL6</option>
                          <option value="437084CM4">437084CM4</option>
                          <option value="437084CN2">437084CN2</option>
                          <option value="437096AA8">437096AA8</option>
                          <option value="437096AB6">437096AB6</option>
                          <option value="437096AC4">437096AC4</option>
                          <option value="437096AD2">437096AD2</option>
                          <option value="437096AE0">437096AE0</option>
                          <option value="437096AF7">437096AF7</option>
                          <option value="437096AG5">437096AG5</option>
                          <option value="437096AH3">437096AH3</option>
                          <option value="437096AI1">437096AI1</option>
                          <option value="437096AJ9">437096AJ9</option>
                          <option value="437096AK6">437096AK6</option>
                          <option value="437096AL4">437096AL4</option>
                          <option value="437097AA6">437097AA6</option>
                          <option value="437097AB4">437097AB4</option>
                          <option value="437097AC2">437097AC2</option>
                          <option value="437097AD0">437097AD0</option>
                          <option value="437097AE8">437097AE8</option>
                          <option value="437097AF5">437097AF5</option>
                          <option value="437097AG3">437097AG3</option>
                          <option value="437097AH1">437097AH1</option>
                          <option value="437097AI9">437097AI9</option>
                          <option value="437097AJ7">437097AJ7</option>
                          <option value="437097AK4">437097AK4</option>
                          <option value="437097AL2">437097AL2</option>
                          <option value="43709NAA1">43709NAA1</option>
                          <option value="43709NAB9">43709NAB9</option>
                          <option value="43709NAC7">43709NAC7</option>
                          <option value="43709NAD5">43709NAD5</option>
                          <option value="43709NAE3">43709NAE3</option>
                          <option value="43709NAF0">43709NAF0</option>
                          <option value="43709NAG8">43709NAG8</option>
                          <option value="43709NAH6">43709NAH6</option>
                          <option value="43709NAI4">43709NAI4</option>
                          <option value="43709NAJ2">43709NAJ2</option>
                          <option value="43709NAK9">43709NAK9</option>
                          <option value="43709NAL7">43709NAL7</option>
                          <option value="43709QAA7">43709QAA7</option>
                          <option value="43709QAB5">43709QAB5</option>
                          <option value="43709QAC3">43709QAC3</option>
                          <option value="43709QAD1">43709QAD1</option>
                          <option value="43709QAE9">43709QAE9</option>
                          <option value="43709QAF6">43709QAF6</option>
                          <option value="43709QAG4">43709QAG4</option>
                          <option value="43709QAH2">43709QAH2</option>
                          <option value="43709QAI0">43709QAI0</option>
                          <option value="43709QAJ8">43709QAJ8</option>
                          <option value="43709QAK5">43709QAK5</option>
                          <option value="43709QAL3">43709QAL3</option>
                          <option value="43710LAA0">43710LAA0</option>
                          <option value="43710LAB8">43710LAB8</option>
                          <option value="43710LAC6">43710LAC6</option>
                          <option value="43710LAD4">43710LAD4</option>
                          <option value="43710LAE2">43710LAE2</option>
                          <option value="43710LAF9">43710LAF9</option>
                          <option value="43710LAG7">43710LAG7</option>
                          <option value="43710LAH5">43710LAH5</option>
                          <option value="43710LAI3">43710LAI3</option>
                          <option value="43710LAJ1">43710LAJ1</option>
                          <option value="43710LAK8">43710LAK8</option>
                          <option value="43710LAL6">43710LAL6</option>
                          <option value="43710NAA6">43710NAA6</option>
                          <option value="43710NAB4">43710NAB4</option>
                          <option value="43710NAC2">43710NAC2</option>
                          <option value="43710NAD0">43710NAD0</option>
                          <option value="43710NAE8">43710NAE8</option>
                          <option value="43710NAF5">43710NAF5</option>
                          <option value="43710NAG3">43710NAG3</option>
                          <option value="43710NAH1">43710NAH1</option>
                          <option value="43710NAI9">43710NAI9</option>
                          <option value="43710NAJ7">43710NAJ7</option>
                          <option value="43710NAK4">43710NAK4</option>
                          <option value="43710NAL2">43710NAL2</option>
                          <option value="43710TAA5">43710TAA5</option>
                          <option value="43710TAB3">43710TAB3</option>
                          <option value="43710TAC1">43710TAC1</option>
                          <option value="43710TAD9">43710TAD9</option>
                          <option value="43710TAE7">43710TAE7</option>
                          <option value="43710TAF4">43710TAF4</option>
                          <option value="43710TAG2">43710TAG2</option>
                          <option value="43710TAH0">43710TAH0</option>
                          <option value="43710TAI8">43710TAI8</option>
                          <option value="43710TAJ6">43710TAJ6</option>
                          <option value="43710TAK3">43710TAK3</option>
                          <option value="43710TAL1">43710TAL1</option>
                          <option value="43709JAA0">43709JAA0</option>
                          <option value="43709JAB8">43709JAB8</option>
                          <option value="43709JAC6">43709JAC6</option>
                          <option value="43709JAD4">43709JAD4</option>
                          <option value="43709JAE2">43709JAE2</option>
                          <option value="43709JAF9">43709JAF9</option>
                          <option value="43709JAG7">43709JAG7</option>
                          <option value="43709JAH5">43709JAH5</option>
                          <option value="43709JAI3">43709JAI3</option>
                          <option value="43709JAJ1">43709JAJ1</option>
                          <option value="43709JAK8">43709JAK8</option>
                          <option value="43709JAL6">43709JAL6</option>
                          <option value="43709JAM4">43709JAM4</option>
                          <option value="43709JAN2">43709JAN2</option>
                          <option value="43709JAO0">43709JAO0</option>
                          <option value="43709PAA6">43709PAA6</option>
                          <option value="43709PAB4">43709PAB4</option>
                          <option value="43709PAC2">43709PAC2</option>
                          <option value="43709PAD0">43709PAD0</option>
                          <option value="43709PAE8">43709PAE8</option>
                          <option value="43709PAF5">43709PAF5</option>
                          <option value="43709PAG3">43709PAG3</option>
                          <option value="43709PAH1">43709PAH1</option>
                          <option value="43709PAI9">43709PAI9</option>
                          <option value="43709PAK4">43709PAK4</option>
                          <option value="43709PAL2">43709PAL2</option>
                          <option value="43709PAM0">43709PAM0</option>
                          <option value="43709PAN8">43709PAN8</option>
                          <option value="43709PAO6">43709PAO6</option>
                          <option value="43709YAA7">43709YAA7</option>
                          <option value="43709YAB5">43709YAB5</option>
                          <option value="43709YAC3">43709YAC3</option>
                          <option value="43709YAD1">43709YAD1</option>
                          <option value="43709YAE9">43709YAE9</option>
                          <option value="43709YAF6">43709YAF6</option>
                          <option value="43709YAG4">43709YAG4</option>
                          <option value="43709YAH2">43709YAH2</option>
                          <option value="43709YAI0">43709YAI0</option>
                          <option value="43709YAJ8">43709YAJ8</option>
                          <option value="43709YAK5">43709YAK5</option>
                          <option value="43709YAL3">43709YAL3</option>
                          <option value="43709YAM1">43709YAM1</option>
                          <option value="43709YAN9">43709YAN9</option>
                          <option value="43709YAO7">43709YAO7</option>
                          <option value="43710AAA5">43710AAA5</option>
                          <option value="43710AAB3">43710AAB3</option>
                          <option value="43710AAC1">43710AAC1</option>
                          <option value="43710AAD9">43710AAD9</option>
                          <option value="43710AAE7">43710AAE7</option>
                          <option value="43710AAF4">43710AAF4</option>
                          <option value="43710AAG2">43710AAG2</option>
                          <option value="43710AAH0">43710AAH0</option>
                          <option value="43710AAI8">43710AAI8</option>
                          <option value="43710AAJ6">43710AAJ6</option>
                          <option value="43710AAK3">43710AAK3</option>
                          <option value="43710AAL1">43710AAL1</option>
                          <option value="43710AAM9">43710AAM9</option>
                          <option value="43710AAN7">43710AAN7</option>
                          <option value="43710AAO5">43710AAO5</option>
                          <option value="43710CAA2">43710CAA2</option>
                          <option value="43710CAB0">43710CAB0</option>
                          <option value="43710CAC8">43710CAC8</option>
                          <option value="43710CAD6">43710CAD6</option>
                          <option value="43710CAE4">43710CAE4</option>
                          <option value="43710CAF1">43710CAF1</option>
                          <option value="43710CAG9">43710CAG9</option>
                          <option value="43710CAH7">43710CAH7</option>
                          <option value="43710CAI5">43710CAI5</option>
                          <option value="43710CAJ3">43710CAJ3</option>
                          <option value="43710CAK0">43710CAK0</option>
                          <option value="43710CAL8">43710CAL8</option>
                          <option value="43710CAM6">43710CAM6</option>
                          <option value="43710CAN4">43710CAN4</option>
                          <option value="43710CAO2">43710CAO2</option>
                        </select>-->
                        <div *ngIf="clicked && g.salesCusip.errors" class="invalid-feedback">
                          <div *ngIf="g.salesCusip.errors.required">This field is required</div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="salesPricePerShare">
                          Price (excluding interest, commissions, taxes and fees):
                        </label>
                        <input type="text" class="form-control" formControlName="salesPricePerShare" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.salesPricePerShare.errors }" />
                        <div *ngIf="clicked && g.salesPricePerShare.errors" class="invalid-feedback">
                          <div *ngIf="g.salesPricePerShare.errors.required">This field is required</div>
                          <div *ngIf="g.salesPricePerShare.errors.maxlength">This field cannot be more than 11 digits</div>
                          <div *ngIf="g.salesPricePerShare.errors.pattern">Only use numbers with optional period (.) and up to 6 digits before the decimal, and 4 digits passed the decimal.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="titleBold" for="salesTotalPrice">
                          Total Proceeds (excluding interest, commissions, taxes and fees):
                        </label>
                        <input type="text" class="form-control" formControlName="salesTotalPrice" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.salesTotalPrice.errors }" />
                        <div *ngIf="clicked && g.salesTotalPrice.errors" class="invalid-feedback">
                          <div *ngIf="g.salesTotalPrice.errors.required">This field is required</div>
                          <div *ngIf="g.salesTotalPrice.errors.maxlength">This field cannot be more than 11 digits</div>
                          <div *ngIf="g.salesTotalPrice.errors.pattern">Only use numbers with optional period (.) and up to 6 digits before the decimal, and 4 digits passed the decimal.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button type="button" (click)="addSalesData()" class="btn btn-success">Add Sale Information</button>&nbsp;
                      <button type="button" (click)="clearSalesData()" class="btn btn-danger btn-sm">Clear Sale Information</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table" #listofFiles>
                    <thead>
                      <tr>
                        <th class="tableHeaderFormattedText">Trade Date</th>
                        <th class="tableHeaderFormattedText">Face Value</th>
                        <th class="tableHeaderFormattedText">CUSIP</th>
                        <th class="tableHeaderFormattedText">Sale Price Per Share</th>
                        <th class="tableHeaderFormattedText">Total Cost</th>
                        <th class="tableHeaderFormattedText">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let sl of saleList; let i = index">
                        <td class="hidden">{{i}}</td>
                        <td class="tableRowFormattedText">{{sl.TradeDate | date:'MM/dd/yyyy'}}</td>
                        <td class="tableRowFormattedText">{{sl.Quantity}}</td>
                        <td class="tableRowFormattedText">{{sl.Cusip}}</td>
                        <td class="tableRowFormattedText">{{sl.PricePerShare}}</td>
                        <td class="tableRowFormattedText">{{sl.TotalPrice}}</td>
                        <td>
                          <button type="button" class="btn btn-danger"
                                  (click)="removeSalesRow(i)">
                            Remove
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="card card-body bg-light mt-3">
              <div class="card-header bg-primary text-white">
                Closing Transactions
              </div>
              <br />
              <div class="row mb-3">
                <div class="col-md-12">
                  <b>D.	CERTIFICATES HELD</b> –
                  List all included RMBS Trust Certificates you held as of December 18, 2013<br /><br />
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="titleBold" for="closingQuantity">
                          Face Value:
                        </label>
                        <input type="text" class="form-control" formControlName="closingQuantity" autocomplete="no" trim="blur"
                               [ngClass]="{ 'is-invalid': clicked && g.closingQuantity.errors }" />
                        <div *ngIf="clicked && g.closingQuantity.errors" class="invalid-feedback">
                          <div *ngIf="g.closingQuantity.errors.required">This field is required</div>
                          <div *ngIf="g.closingQuantity.errors.maxlength">This field cannot be more than 12 digits</div>
                          <div *ngIf="g.closingQuantity.errors.pattern">Only use numbers with optional period (.), optional negative sign (-), and up to 6 digits before the decimal, and 4 digits passed the decimal.</div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="titleBold" for="closingCusip">
                          CUSIP
                        </label>
                        <select class="form-control" formControlName="closingCusip" [ngClass]="{ 'is-invalid': g.closingCusip.errors }">
                          <option value="">Please Select an Option</option>
                          <option *ngFor="let allCusip of allCusips">
                            {{allCusip.Name}}
                          </option>
                        </select>




                        <!--<select class="form-control" formControlName="closingCusip"
                                [ngClass]="{ 'is-invalid': g.closingCusip.errors }">
                          <option value="">Please Select an Option</option>
                          <option value="437084CD4">437084CD4</option>
                          <option value="437084CE2">437084CE2</option>
                          <option value="437084CF9">437084CF9</option>
                          <option value="437084CG7">437084CG7</option>
                          <option value="437084CH5">437084CH5</option>
                          <option value="437084CI3">437084CI3</option>
                          <option value="437084CJ1">437084CJ1</option>
                          <option value="437084CK8">437084CK8</option>
                          <option value="437084CL6">437084CL6</option>
                          <option value="437084CM4">437084CM4</option>
                          <option value="437084CN2">437084CN2</option>
                          <option value="437096AA8">437096AA8</option>
                          <option value="437096AB6">437096AB6</option>
                          <option value="437096AC4">437096AC4</option>
                          <option value="437096AD2">437096AD2</option>
                          <option value="437096AE0">437096AE0</option>
                          <option value="437096AF7">437096AF7</option>
                          <option value="437096AG5">437096AG5</option>
                          <option value="437096AH3">437096AH3</option>
                          <option value="437096AI1">437096AI1</option>
                          <option value="437096AJ9">437096AJ9</option>
                          <option value="437096AK6">437096AK6</option>
                          <option value="437096AL4">437096AL4</option>
                          <option value="437097AA6">437097AA6</option>
                          <option value="437097AB4">437097AB4</option>
                          <option value="437097AC2">437097AC2</option>
                          <option value="437097AD0">437097AD0</option>
                          <option value="437097AE8">437097AE8</option>
                          <option value="437097AF5">437097AF5</option>
                          <option value="437097AG3">437097AG3</option>
                          <option value="437097AH1">437097AH1</option>
                          <option value="437097AI9">437097AI9</option>
                          <option value="437097AJ7">437097AJ7</option>
                          <option value="437097AK4">437097AK4</option>
                          <option value="437097AL2">437097AL2</option>
                          <option value="43709NAA1">43709NAA1</option>
                          <option value="43709NAB9">43709NAB9</option>
                          <option value="43709NAC7">43709NAC7</option>
                          <option value="43709NAD5">43709NAD5</option>
                          <option value="43709NAE3">43709NAE3</option>
                          <option value="43709NAF0">43709NAF0</option>
                          <option value="43709NAG8">43709NAG8</option>
                          <option value="43709NAH6">43709NAH6</option>
                          <option value="43709NAI4">43709NAI4</option>
                          <option value="43709NAJ2">43709NAJ2</option>
                          <option value="43709NAK9">43709NAK9</option>
                          <option value="43709NAL7">43709NAL7</option>
                          <option value="43709QAA7">43709QAA7</option>
                          <option value="43709QAB5">43709QAB5</option>
                          <option value="43709QAC3">43709QAC3</option>
                          <option value="43709QAD1">43709QAD1</option>
                          <option value="43709QAE9">43709QAE9</option>
                          <option value="43709QAF6">43709QAF6</option>
                          <option value="43709QAG4">43709QAG4</option>
                          <option value="43709QAH2">43709QAH2</option>
                          <option value="43709QAI0">43709QAI0</option>
                          <option value="43709QAJ8">43709QAJ8</option>
                          <option value="43709QAK5">43709QAK5</option>
                          <option value="43709QAL3">43709QAL3</option>
                          <option value="43710LAA0">43710LAA0</option>
                          <option value="43710LAB8">43710LAB8</option>
                          <option value="43710LAC6">43710LAC6</option>
                          <option value="43710LAD4">43710LAD4</option>
                          <option value="43710LAE2">43710LAE2</option>
                          <option value="43710LAF9">43710LAF9</option>
                          <option value="43710LAG7">43710LAG7</option>
                          <option value="43710LAH5">43710LAH5</option>
                          <option value="43710LAI3">43710LAI3</option>
                          <option value="43710LAJ1">43710LAJ1</option>
                          <option value="43710LAK8">43710LAK8</option>
                          <option value="43710LAL6">43710LAL6</option>
                          <option value="43710NAA6">43710NAA6</option>
                          <option value="43710NAB4">43710NAB4</option>
                          <option value="43710NAC2">43710NAC2</option>
                          <option value="43710NAD0">43710NAD0</option>
                          <option value="43710NAE8">43710NAE8</option>
                          <option value="43710NAF5">43710NAF5</option>
                          <option value="43710NAG3">43710NAG3</option>
                          <option value="43710NAH1">43710NAH1</option>
                          <option value="43710NAI9">43710NAI9</option>
                          <option value="43710NAJ7">43710NAJ7</option>
                          <option value="43710NAK4">43710NAK4</option>
                          <option value="43710NAL2">43710NAL2</option>
                          <option value="43710TAA5">43710TAA5</option>
                          <option value="43710TAB3">43710TAB3</option>
                          <option value="43710TAC1">43710TAC1</option>
                          <option value="43710TAD9">43710TAD9</option>
                          <option value="43710TAE7">43710TAE7</option>
                          <option value="43710TAF4">43710TAF4</option>
                          <option value="43710TAG2">43710TAG2</option>
                          <option value="43710TAH0">43710TAH0</option>
                          <option value="43710TAI8">43710TAI8</option>
                          <option value="43710TAJ6">43710TAJ6</option>
                          <option value="43710TAK3">43710TAK3</option>
                          <option value="43710TAL1">43710TAL1</option>
                          <option value="43709JAA0">43709JAA0</option>
                          <option value="43709JAB8">43709JAB8</option>
                          <option value="43709JAC6">43709JAC6</option>
                          <option value="43709JAD4">43709JAD4</option>
                          <option value="43709JAE2">43709JAE2</option>
                          <option value="43709JAF9">43709JAF9</option>
                          <option value="43709JAG7">43709JAG7</option>
                          <option value="43709JAH5">43709JAH5</option>
                          <option value="43709JAI3">43709JAI3</option>
                          <option value="43709JAJ1">43709JAJ1</option>
                          <option value="43709JAK8">43709JAK8</option>
                          <option value="43709JAL6">43709JAL6</option>
                          <option value="43709JAM4">43709JAM4</option>
                          <option value="43709JAN2">43709JAN2</option>
                          <option value="43709JAO0">43709JAO0</option>
                          <option value="43709PAA6">43709PAA6</option>
                          <option value="43709PAB4">43709PAB4</option>
                          <option value="43709PAC2">43709PAC2</option>
                          <option value="43709PAD0">43709PAD0</option>
                          <option value="43709PAE8">43709PAE8</option>
                          <option value="43709PAF5">43709PAF5</option>
                          <option value="43709PAG3">43709PAG3</option>
                          <option value="43709PAH1">43709PAH1</option>
                          <option value="43709PAI9">43709PAI9</option>
                          <option value="43709PAK4">43709PAK4</option>
                          <option value="43709PAL2">43709PAL2</option>
                          <option value="43709PAM0">43709PAM0</option>
                          <option value="43709PAN8">43709PAN8</option>
                          <option value="43709PAO6">43709PAO6</option>
                          <option value="43709YAA7">43709YAA7</option>
                          <option value="43709YAB5">43709YAB5</option>
                          <option value="43709YAC3">43709YAC3</option>
                          <option value="43709YAD1">43709YAD1</option>
                          <option value="43709YAE9">43709YAE9</option>
                          <option value="43709YAF6">43709YAF6</option>
                          <option value="43709YAG4">43709YAG4</option>
                          <option value="43709YAH2">43709YAH2</option>
                          <option value="43709YAI0">43709YAI0</option>
                          <option value="43709YAJ8">43709YAJ8</option>
                          <option value="43709YAK5">43709YAK5</option>
                          <option value="43709YAL3">43709YAL3</option>
                          <option value="43709YAM1">43709YAM1</option>
                          <option value="43709YAN9">43709YAN9</option>
                          <option value="43709YAO7">43709YAO7</option>
                          <option value="43710AAA5">43710AAA5</option>
                          <option value="43710AAB3">43710AAB3</option>
                          <option value="43710AAC1">43710AAC1</option>
                          <option value="43710AAD9">43710AAD9</option>
                          <option value="43710AAE7">43710AAE7</option>
                          <option value="43710AAF4">43710AAF4</option>
                          <option value="43710AAG2">43710AAG2</option>
                          <option value="43710AAH0">43710AAH0</option>
                          <option value="43710AAI8">43710AAI8</option>
                          <option value="43710AAJ6">43710AAJ6</option>
                          <option value="43710AAK3">43710AAK3</option>
                          <option value="43710AAL1">43710AAL1</option>
                          <option value="43710AAM9">43710AAM9</option>
                          <option value="43710AAN7">43710AAN7</option>
                          <option value="43710AAO5">43710AAO5</option>
                          <option value="43710CAA2">43710CAA2</option>
                          <option value="43710CAB0">43710CAB0</option>
                          <option value="43710CAC8">43710CAC8</option>
                          <option value="43710CAD6">43710CAD6</option>
                          <option value="43710CAE4">43710CAE4</option>
                          <option value="43710CAF1">43710CAF1</option>
                          <option value="43710CAG9">43710CAG9</option>
                          <option value="43710CAH7">43710CAH7</option>
                          <option value="43710CAI5">43710CAI5</option>
                          <option value="43710CAJ3">43710CAJ3</option>
                          <option value="43710CAK0">43710CAK0</option>
                          <option value="43710CAL8">43710CAL8</option>
                          <option value="43710CAM6">43710CAM6</option>
                          <option value="43710CAN4">43710CAN4</option>
                          <option value="43710CAO2">43710CAO2</option>
                        </select>-->
                        <div *ngIf="clicked && g.closingCusip.errors" class="invalid-feedback">
                          <div *ngIf="g.closingCusip.errors.required">This field is required</div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button type="button" (click)="addClosingsData()" class="btn btn-success">Add Closing Information</button>&nbsp;
                      <button type="button" (click)="clearClosingsData()" class="btn btn-danger btn-sm">Clear Closing Information</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table" #listofFiles>
                    <thead>
                      <tr>
                        <th class="tableHeaderFormattedText">Face Value</th>
                        <th class="tableHeaderFormattedText">CUSIP</th>
                        <th class="tableHeaderFormattedText">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let cl of closingList; let i = index">
                        <td class="hidden">{{i}}</td>
                        <td class="tableRowFormattedText">{{cl.Quantity}}</td>
                        <td class="tableRowFormattedText">{{cl.Cusip}}</td>
                        <td>
                          <button type="button" class="btn btn-danger"
                                  (click)="removeClosingsRow(i)">
                            Remove
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <br />
            <div class="text-center" *ngIf="showMessage" style="color:red; font-weight:bold; font-size:1.3em">
              You forgot to click one or more of the add buttons to save your transactions. Please make sure you clicked the add button and try again.
            </div>
            <br />
            <ul class="list-inline float-right">
              <li>
                <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
                <button class="btn btn-primary" (click)="saveAndValidateStepThree()">Next</button>
              </li>
            </ul>

          </div>
        </div>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="stepFourForm">
    <form [formGroup]="stepFourForm">
      <!--<ng-template cdkStepLabel>
      <div class="step-bullet"></div>
      <div class="step-title"></div>
      </ng-template>-->
      <div class="card border-0">
        <div class="card-body">

          <div style="font-size: 1.0em;">
            <div class="row">
              <div class="col-md-12">
                <div class="text-center" style="margin-top:1%; font-weight:bold; font-size:1.4em; text-decoration:underline">
                  <u>E.	ATTACH REQUIRED DOCUMENTS</u>
                </div>
                <br />
                <div class="row">
                  <div class="col-md-12">
                    Attach copies of broker confirmations or other documents that support your listed transactions in RMBS Trust
                    Certificates. DO NOT SEND ORIGINAL DOCUMENTS.<br /><br />

                    Supporting documents may include: (a) brokerage or trade confirmation slips, (b) monthly brokerage account
                    statements, (c) an authorized statement from your broker containing the transactional and holding information,
                    (d) a signed letter from your broker on firm letterhead verifying the information you are providing, or (e)
                    other equivalent proof of your transactions.<br /><br />

                    All documentation must be legible and include all information necessary to support the information on your
                    Claim Form. If the name appears different on the supporting documentation, you must provide proof of name/
                    bank account change.<br /><br />

                    If you do not provide supporting documents, your claim may be delayed or rejected.<br /><br />

                    <b>Please keep a copy of all documents that you send to the Claims Administrator.  Also, please do not highlight any portion of the Claim Form or any supporting documents.</b>
                  </div>
                </div>

              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <input type="file" id="file" #fileInput (change)="getFileDetails($event)" multiple class="form-control form-control-sm hidden" />
                <label for="file" class="btn btn-primary btn-sm">Documents To Upload</label>
                <br />
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-sm-12">
                <table class="table" #listofFiles>
                  <thead>
                    <tr>
                      <th class="hidden">Id</th>
                      <th>Files To Be Uploaded</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let sd of supportingDocuments; let i = index">
                      <td class="hidden">{{i}}</td>
                      <td>{{sd.name}}</td>
                      <td>
                        <button type="button" class="btn btn-danger" (click)="removeRow(i)">Remove</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br />
            <ul class="list-inline float-right">
              <li>
                <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
                <button class="btn btn-primary" matStepperNext (click)="saveAndValidateStepFour()">Next</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="stepFiveForm">
    <form [formGroup]="stepFiveForm">
      <!--<ng-template cdkStepLabel>
      <div class="step-bullet"></div>
      <div class="step-title"></div>
      </ng-template>-->
      <div class="card border-0">
        <div class="card-body">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <p class="text-center" style="font-size: 1.8em; color: #000000; margin-top: 2%; font-family:Arial, Helvetica, sans-serif; font-weight:bold">
                  NJBOS Credit Suisse Settlement
                </p>
              </div>
            </div>
          </div>
          <div class="container" style="border:1px solid #bebaba">
            <div class="text-center" style="margin-top:1%; font-weight:bold; font-size:1.4em; text-decoration:underline">
              PART III – SIGNATURE AND CERTICIATIONS
            </div>
            <br />

            <div class="row">
              <div class="col-md-12" style="font-size: 1.0em; text-align: justify; text-justify: distribute-all-lines">
                I (We) declare UNDER PENALTY OF PERJURY, under the laws of the United States of America, that:<br /><br />

                1.	I (We) have read my (our) Claim Form, including any attachments and supporting documents, and verify that they are true and correct;<br /><br />

                2.	I (We) am (are) eligible to apply for a restitution payment and am (are) not excluded (as defined in the Plan of Allocation);<br /><br />

                3.	I (We) understand that the deadline to apply for a restitution payment is October 6, 2026, and if we do not submit our completed Claim Form and
                supporting documents by that deadline, our application may be rejected;<br /><br />

                4.	I (We) agree to provide additional information about this Claim Form if required by the Claims Administrator in order to receive a restitution
                payment;<br /><br />

                5.	I (We) have not authorized, nor am I (are We) aware of, anyone else who has filed a Claim Form on my (our) behalf for the same Securities
                covered in this Claim Form; and<br /><br />

                6.	All notices should be sent to me (us) at the information I (we) provided in this Claim Form, and I (we) will notify the Claims Administrator,
                in writing, if any of my (our) contact information changes.<br /><br />

                I (We) declare under penalty of perjury under the laws of the United States of America that the foregoing information supplied by the undersigned is true and correct.
                <br /><br />

                <div class="row mt-4">
                  <div class="col-md-12">
                    <div class="form-group form-check">
                      <input type="checkbox" formControlName="irsBackUpWithHolding" class="form-check-input" />
                      <label for="irsBackUpWithHolding">
                        <b>
                          NOTE: If you have been notified by the I.R.S. that you are subject to backup withholding, please check this box.
                        </b>
                      </label>
                    </div>
                  </div>
                </div>


              </div>
            </div>
            <div style="font-size: 1.0em;">
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="signature"><b>Signature of Claimant:</b><span style="color:red" class="required"> *</span></label>
                    <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                           trim="blur" [ngClass]="{ 'is-invalid': h.signature.errors }" />
                    <div *ngIf="h.signature.errors" class="invalid-feedback">
                      <div *ngIf="h.signature.errors.required">This field is required</div>
                      <div *ngIf="h.signature.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="h.signature.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="h.signature.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens,
                        brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="jointClaimantSignature"><b>Signature of joint Claimant, if any:</b></label>
                    <input type="text" class="form-control" id="jointClaimantSignature" formControlName="jointClaimantSignature" autocomplete="no"
                           trim="blur" [ngClass]="{ 'is-invalid': h.jointClaimantSignature.errors }" />
                    <div *ngIf="h.jointClaimantSignature.errors" class="invalid-feedback">
                      <div *ngIf="h.jointClaimantSignature.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="h.jointClaimantSignature.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="h.jointClaimantSignature.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens,
                        brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="signingOnBehalfCapacity">
                      <b>
                        Signature of person signing on behalf of Claimant:
                      </b>
                    </label>
                    <input type="text" class="form-control" id="signingOnBehalfCapacity" formControlName="signingOnBehalfCapacity" autocomplete="no"
                           trim="blur" [ngClass]="{ 'is-invalid': h.signingOnBehalfCapacity.errors }" />
                    <div *ngIf="h.signingOnBehalfCapacity.errors" class="invalid-feedback">
                      <div *ngIf="h.signingOnBehalfCapacity.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="h.signingOnBehalfCapacity.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="h.signingOnBehalfCapacity.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens,
                        brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="helperCapacity"><b>Capacity of person(s) signing, <i>e.g.,</i> Beneficial Purchaser, Executor, or Administrator:</b></label>
                    <input type="text" class="form-control" id="helperCapacity" formControlName="helperCapacity" autocomplete="no"
                           trim="blur" [ngClass]="{ 'is-invalid': h.helperCapacity.errors }" />
                    <div *ngIf="h.helperCapacity.errors" class="invalid-feedback">
                      <div *ngIf="h.helperCapacity.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="h.helperCapacity.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="h.helperCapacity.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens,
                        brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid': submitted && h.googleRecaptchaToken.errors }"></re-captcha>
                    <div *ngIf="submitted && h.googleRecaptchaToken.errors" class="invalid-feedback">
                      <div *ngIf="h.googleRecaptchaToken.errors.required" style="color:red; font-size:80%">This field is required</div>
                    </div>
                    <!--<div style="color:#dc3545; font-size:80%; font-weight:bold">This field is required*</div>-->

                  </div>
                </div>
              </div>
              <br />              <div class="row">
                <div class="col-md-12">
                  <h4 class="text-center" style="font-weight:bold; text-align:center">
                    ACCURATE CLAIMS PROCESSING TAKES A<br /> SIGNIFICANT AMOUNT OF TIME.<br /> THANK YOU FOR YOUR PATIENCE.
                  </h4>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <h5 class="text-center" style="text-decoration:underline">
                    REMINDER CHECKLIST:
                  </h5>
                </div>

                <div class="col-md-12" style="text-align:justify; text-justify:auto; margin-top:2%">
                  1.	<b>Sign the Claim Form</b>. Make sure your Claim Form is complete and signed.<br /><br />
                  2.	<b>Attach Supporting Documents</b>. Attach copies of all required supporting documents.  DO NOT provide originals of brokerage
                  statements or other documents. They will not be returned.<br /><br />
                  3.	<b>Do not highlight</b> any part of the Claim Form or your supporting documents.<br /><br />
                  4.	Keep copies.  Keep a copy of the Claim Form and supporting documents for your own records.<br /><br />
                  5.	Submit your Claim Form by October 6, 2026. This Claim Form and your supporting documents must be submitted online at
                  www.NJBOSCreditSuisseSettlement.com at or before 11:59 p.m. (ET) on October 6, 2026, or mailed so it is postmarked no
                  later than October 6, 2026, to:<br /><br />

                  <p style="text-align:center">
                    NJBOS Credit Suisse Settlement<br />
                    c/o A.B. Data, Ltd.<br />
                    P.O. Box 173056<br />
                    Milwaukee, WI 53217<br /><br />

                  </p>
                  If you want confirmation that your Claim Form was received, send your Claim Form certified mail, return receipt requested.<br /><br />

                  6.	<b>Notice of Address or Name Changes</b>. Notify the Claims Administrator if your name, address, or any of your contact information changes in the future.<br /><br />
                  7.	<b>Additional Questions?</b><br /><br />
                  Call: 1-877-254-8530<br />
                  Visit: www.NJBOSCreditSuisseSettlement.com<br />
                  Email: info@NJBOSCreditSuisseSettlement.com<br />
                  Write to: NJBOS Credit Suisse Settlement, c/o A.B. Data, Ltd., P.O. Box 173056, Milwaukee, WI 53217<br />
                </div>

              </div>
              <br /><br />
              <div class="row">
                <div class="col-md-12 text-center">
                  <div *ngIf="showDivSubmittalErrorMessage == true" class="submittal-custom-error" style="color:red">
                    Submission failed, please review your entries for errors.
                  </div>
                </div>
              </div>
              <br />
              <div class="row" *ngIf="showSubmittalErrorWarning" style="background-color:lightpink">
                <div class="col-md-12 text-center" style="font-weight:bold">
                  Claim Submission Failed, click <a href="https://www.NJBOSCreditSuisseSettlement.com" target="_blank">here </a>
                  to download a copy of the Claim Form and send it via email.<br />
                  Thank You.
                </div>
              </div>
              <br />
              <ul class="list-inline float-right">
                <li>
                  <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
                  <button class="btn btn-primary" [disabled]="submitClicked" (click)="onSubmit()" type="submit">Submit</button>
                </li>
              </ul>
              <br /><br />
            </div>
          </div>
        </div>
      </div>

    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Saving Data...</p>
    </ngx-spinner>
  </mat-step>

</mat-horizontal-stepper>

